import { useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import api from "../../services/api";

export default function BuscadorClienteExpediente({ onSeleccionar, isDark, placeholder }) {
  const [texto, setTexto] = useState("");
  const [resultados, setResultados] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [menuPos, setMenuPos] = useState(null);
  const timerRef = useRef(null);
  const inputRef = useRef(null);

  const tx = isDark ? "#f9fafb" : "#111827";

  const inputSt = {
    padding: "6px 8px", borderRadius: 6, fontSize: 12, width: "100%",
    background: isDark ? "#1f2937" : "#fff",
    border: `1px solid ${isDark ? "#374151" : "#c8c8be"}`,
    color: tx, outline: "none", fontFamily: "inherit", boxSizing: "border-box",
  };

  const actualizarPosMenu = () => {
    const el = inputRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setMenuPos({ top: r.bottom + 3, left: r.left, width: Math.max(r.width, 280) });
  };

  useLayoutEffect(() => {
    if (!abierto) { setMenuPos(null); return; }
    actualizarPosMenu();
    const onScroll = () => actualizarPosMenu();
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", onScroll);
    };
  }, [abierto, resultados.length, cargando]);

  const ejecutarBusqueda = async (q) => {
    if (q.length < 2) {
      setResultados([]);
      setAbierto(q.length > 0);
      setCargando(false);
      return;
    }
    setCargando(true);
    try {
      const r = await api.get(`/clientes?buscar=${encodeURIComponent(q)}&bucket=activos`);
      setResultados(r.data?.data || []);
      setAbierto(true);
    } catch {
      setResultados([]);
      setAbierto(true);
    } finally {
      setCargando(false);
    }
  };

  const buscar = (q) => {
    setTexto(q);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => ejecutarBusqueda(q.trim()), 280);
  };

  const seleccionar = (c) => {
    onSeleccionar(c);
    setTexto("");
    setResultados([]);
    setAbierto(false);
  };

  const menu = abierto && menuPos && createPortal(
    <div
      style={{
        position: "fixed",
        top: menuPos.top,
        left: menuPos.left,
        width: menuPos.width,
        zIndex: 13000,
        background: isDark ? "#121820" : "#fff",
        border: `1px solid ${isDark ? "#5a6a80" : "#d1d5db"}`,
        borderRadius: 6,
        boxShadow: "0 12px 32px rgba(0,0,0,0.35)",
        maxHeight: 220,
        overflowY: "auto",
      }}
      onMouseDown={(e) => e.preventDefault()}
    >
      {cargando && (
        <div style={{ padding: "8px 10px", fontSize: 11, color: tx, opacity: 0.8 }}>Buscando...</div>
      )}
      {!cargando && resultados.length === 0 && (
        <div style={{ padding: "8px 10px", fontSize: 11, color: tx, opacity: 0.85 }}>
          {texto.trim().length < 2 ? "Escribe al menos 2 caracteres" : "Sin clientes en CRM"}
        </div>
      )}
      {!cargando && resultados.map((c) => (
        <div
          key={c.id}
          onMouseDown={() => seleccionar(c)}
          style={{
            padding: "7px 10px", cursor: "pointer", fontSize: 12,
            borderBottom: `1px solid ${isDark ? "#374151" : "#f3f4f6"}`,
            color: tx,
          }}
        >
          <strong>{c.nombre} {c.apellido || ""}</strong>
          {c.telefono && <span style={{ marginLeft: 6, opacity: 0.7 }}>{c.telefono}</span>}
        </div>
      ))}
    </div>,
    document.body,
  );

  return (
    <>
      <input
        ref={inputRef}
        value={texto}
        onChange={(e) => buscar(e.target.value)}
        placeholder={placeholder || "Nombre, teléfono, email..."}
        style={inputSt}
        onFocus={() => { if (texto.trim().length >= 2) setAbierto(true); }}
        onBlur={() => setTimeout(() => setAbierto(false), 200)}
      />
      {menu}
    </>
  );
}
